// Function to create a banner element
function createBanner({ href, src, alt, text, classes }) {
  const banner = document.createElement('div');
  if (href && src) {
    banner.innerHTML = `<a href="${href}"><img src="${src}" alt="${alt}" width="" height=""></a>`;
  } else if (src) {
    banner.innerHTML = `<img src="${src}" alt="${alt}" width="" height="">`;
  }
  if (text) {
    const paragraph = document.createElement('p');
    paragraph.innerHTML = text;
    banner.appendChild(paragraph);
  }
  classes.forEach(cls => banner.classList.add(cls));
  return banner;
}

// Function to insert a banner after a specific child
function insertBannerAfter(parent, childIndex, banner) {
  const targetChild = parent.getElementsByTagName('li')[childIndex];
  if (targetChild) {
    targetChild.insertAdjacentElement('afterend', banner);
  }
}

// Main function to handle PLP banner uploads
// function plpBannerUploads() {
//   const collectionElement = document.querySelector('.template-collection');
//   if (!collectionElement) return; // Safeguard if element doesn't exist
//   const parentGrid = collectionElement.querySelector('.productgrid--items');
//   if (!parentGrid) return; // Safeguard if element doesn't exist

//   // First banner details buy3/buy4
//   const firstBannerDetails = {
//     href: "https://www.simpleskincare.in/collections/buy-3-at-999",
//     src: "https://cdn.shopify.com/s/files/1/0560/7017/6931/files/buy3banner.jpg?v=1728288115",
//     alt: "plp-banner",
//     text: `How to Avail: Add any 3 items from <a href="https://www.simpleskincare.in/collections/buy-3-at-999">Collection</a>. Offer auto applies on the cart.`,
//     classes: ['plp-image-banner', 'plp-image-banner-buy3']
//   };

//   // First banner details b2g1
//   // const firstBannerDetails = {
//   //   href: "https://www.simpleskincare.in/collections/all-products",
//   //   src: "https://cdn.shopify.com/s/files/1/0560/7017/6931/files/landing_page_mobile.jpg?v=1740401069",
//   //   alt: "plp-banner",
//   //   text: `How to Avail: Add any 3 items from <a href="https://www.simpleskincare.in/collections/all-products">Collection</a>. Offer auto applies on the cart.`,
//   //   classes: ['plp-image-banner', 'plp-image-banner-buy3']
//   // };

//   // Second banner details
//   const secondBannerDetails = {
//     src: "https://cdn.shopify.com/s/files/1/0560/7017/6931/files/offerbanner.jpg?v=1728288115",
//     alt: "plp-banner",
//     text: null,
//     classes: ['plp-image-banner']
//   };

//   // Create and insert the first banner
//   const firstBanner = createBanner(firstBannerDetails);
//   insertBannerAfter(parentGrid, 5, firstBanner);

//   // Create and insert the second banner
//   const secondBanner = createBanner(secondBannerDetails);
//   insertBannerAfter(parentGrid, 7, secondBanner);
// }

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', plpBannerUploads);
